<script>

    import { fade } from 'svelte/transition'
    import { toast } from 'bulma-toast'
    import { shipmentStore, shipmentsStore } from '../stores'

    import DateMethod from '../$methods/date.method.js'
    import ShipmentsService from '../$services/shipments.service'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let element = null
    let confirmCancel = false

    function closeCancel() {
        if(loading)
            return
        confirmCancel = false
    }

    async function cancelShipment() {

        loading = true
        const resp = await ShipmentsService.cancelShipment($shipmentStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        confirmCancel = false
        shipmentStore.set(resp.data)
        shipmentsStore.replace(resp.data)

        toast({message: 'Guía cancelada', type: 'is-success'})
    }

    async function downloadSignature() {

        loading = true
        const blob = await ShipmentsService.getShipmentSignature($shipmentStore._id)
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        element.download = `${$shipmentStore.guide}.pdf`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

    async function updateShipmentGuideTIL(documentFormat) {

        loading = true
        const resp = await ShipmentsService.updateShipmentGuideTIL($shipmentStore._id, { documentFormat })
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Guía generada correctamente', type: 'is-success'})

        shipmentStore.set(resp.data)
        shipmentsStore.replace(resp.data)
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title={$shipmentStore.guide || 'Envío'}
        meta={DateMethod.dateTimeLarge($shipmentStore.created)}
    >
        <DetailsFields>
            <DetailsField label="Usuario">
                <div>
                    <div>{ $shipmentStore.user.name }</div>
                    <div>{ $shipmentStore.user.email }</div>
                    <div>{ $shipmentStore.user.phone }</div>
                </div>
            </DetailsField>
            <DetailsField label="Tienda">
                <div>
                    <div>{ $shipmentStore.order.storeType }</div>
                    <div>{ $shipmentStore.order.number || '' }</div>
                </div>
            </DetailsField>
            <DetailsField label="Código">
                <span>{ $shipmentStore.code }</span>
                {#if $shipmentStore.order.tag}
                    <span class="tag">{ $shipmentStore.order.tag }</span>
                {/if}
            </DetailsField>
            <DetailsField label="Proveedor" value={$shipmentStore.provider} />
            <DetailsField label="Servicio" value={$shipmentStore.service} />
            <DetailsField label="Peso" value={`${$shipmentStore.order.package.volumetric} kg`} />
            <DetailsField label="Guía">
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                    <div>{ $shipmentStore.guide }</div>
                    {#if $shipmentStore.trackingStatus != 'Cancelado'}
                        <Button on:click={() => confirmCancel = true} text="Cancelar" icon="ban" />
                    {/if}
                </div>
            </DetailsField>
            <DetailsField label="Documento">
                <a href={$shipmentStore.document} class="button is-primary is-fullwidth" target="_blank">
                    <b>Descargar guía</b>
                </a>
            </DetailsField>
            {#if $shipmentStore.folioInsurance}
                <DetailsField label="Número de póliza" value={$shipmentStore.folioInsurance} />
            {/if}
            {#if $shipmentStore.documentInsurance}
                <DetailsField label="Póliza de seguro">
                    <a href={$shipmentStore.documentInsurance} class="button is-primary is-fullwidth" target="_blank">
                        <b>Descargar póliza</b>
                    </a>
                </DetailsField>
            {/if}
            {#if $shipmentStore.signature}
                <DetailsField label="POD">
                    <button type="button" on:click={downloadSignature} class="button is-outlined is-fullwidth">
                        Descargar POD
                    </button>
                </DetailsField>
            {/if}
            {#if $shipmentStore.provider === 'TIL'}
                <DetailsField label="Regenerar etiqueta">
                    <div class="til-buttons">
                        {#if $shipmentStore.documentFormat == 'pdf'}
                            <button type="button" on:click={() => updateShipmentGuideTIL('6x4')} class="button is-outlined is-fullwidth" class:is-loading={loading}>
                                Generar etiqueta 6X4
                            </button>
                        {/if}
                        {#if $shipmentStore.documentFormat == '6x4'}
                            <button type="button" on:click={() => updateShipmentGuideTIL('pdf')} class="button is-outlined is-fullwidth" class:is-loading={loading}>
                                Generar etiqueta PDF
                            </button>
                        {/if}
                    </div>
                </DetailsField>
            {/if}
            <DetailsField label="Rastreo" value={$shipmentStore.trackingNumber || 'Sin número'} mono />
            <DetailsField label="Costo" value={`$${$shipmentStore.pricing.shipmentCost}`} mono />
            <DetailsField label="Seguro" value={`$${$shipmentStore.pricing.insurancePrice}`} mono />
            <DetailsField label="Extras" value={`$${$shipmentStore.pricing.aggregatePrice}`} mono />
            <DetailsField label="Precio">
                <b>${$shipmentStore.pricing.finalPrice}</b>
            </DetailsField>
            <DetailsField label="Entrega Ocurrre">
                <b>{$shipmentStore.order.isOccurs ? 'SI' : 'NO'}</b>
            </DetailsField>
            <DetailsField label="Estatus">
                <div>
                    <div>{ $shipmentStore.trackingStatus }</div>
                    {#if $shipmentStore.trackingStatus === 'Cancelado'}
                        <div>{ DateMethod.dateTimeLarge($shipmentStore.states.canceled) }</div>
                    {/if}
                </div>
            </DetailsField>
            {#if $shipmentStore.evidence}
                <DetailsField label="Evidencia">
                    <a href={$shipmentStore.evidence} class="button is-primary is-fullwidth" target="_blank">
                        <b>Descargar evidencia</b>
                    </a>
                </DetailsField>
            {/if}
            {#if $shipmentStore.refundId}
                <DetailsField label="Reembolso" value={DateMethod.dateTimeLarge($shipmentStore.states.refunded)} />
            {/if}
        </DetailsFields>
    </DetailsCard>
{/if}

{#if confirmCancel}
    <div class="modal is-active confirm-cancel" in:fade={{duration: 200}} out:fade={{duration: 100}}>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div on:click={closeCancel} class="modal-background"></div>
        <div class="modal-card">
            <div class="modal-card-head">
                <div class="modal-card-title">Cancelar envío</div>
                <button on:click={closeCancel} class="delete" aria-label="close"></button>
            </div>
            <div class="modal-card-body">
                <p>¿Confirmas la cancelación de la guía {$shipmentStore.guide}?</p>
                <div class="is-flex is-justify-content-flex-end is-align-items-center mt-4">
                    <Button on:click={closeCancel} text="Volver" icon="ban" />
                    <Button on:click={cancelShipment} text="Cancelar guía" icon="times" color="danger" {loading} />
                </div>
            </div>
            <div class="modal-card-foot"></div>
        </div>
    </div>
{/if}

<style>
    .confirm-cancel {
        z-index: 50;
    }
</style>

